<template>
  <div>
    <div v-if="showTopContent" class="ds-grid">
      <div class="ds-grid__col ds-lg-grid__col--8">
        <h2 v-if="title" class="ds-heading-small ds-md-heading">
          {{ title }}
        </h2>
        <p v-if="description" class="ds-margin-top-12 ds-text">
          {{ description }}
        </p>
      </div>
    </div>
    <DsGrid
      :column-width="{ small: 12, medium: 4, large: largeScreenColumnAmount }"
      :items="items"
      :class="{ 'ds-margin-top-48': showTopContent }"
    >
      <template #default="{ item }">
        <DsCardTextIcon
          v-if="item"
          :icon="item.icon"
          :title="item.title"
          :with-title-size-large="false"
        >
          <RichText v-if="item.description" :data="item.description" class="ds-margin-top-12" />
        </DsCardTextIcon>
      </template>
    </DsGrid>
  </div>
</template>

<script setup>
import {
  DsCardTextIcon,
  DsGrid
} from 'awds'

const props = defineProps({
  items: { type: Array, required: true },
  title: { type: String, default: '' },
  description: { type: String, default: '' }
})

const showTopContent = computed(() => {
  return props.title || props.description
})

const largeScreenColumnAmount = computed(() => {
  return ([4, 7, 8].includes(props.items?.length)) ? 3 : 4
})

</script>
